import sanitizeHtml from 'sanitize-html'

import { basePath } from 'interfaces/constants'
import { Category } from 'interfaces/types'

export const sanitize = (html: string, allowStyle?: boolean) => {
  if (!html) return ''
  return sanitizeHtml(html, {
    allowedTags: [
      'a',
      'abbr',
      'acronym',
      'address',
      'area',
      'article',
      'aside',
      'audio',
      'b',
      'bdi',
      'bdo',
      'big',
      'blink',
      'blockquote',
      'body',
      'br',
      'button',
      'canvas',
      'caption',
      'center',
      'cite',
      'code',
      'col',
      'colgroup',
      'content',
      'data',
      'datalist',
      'dd',
      'decorator',
      'del',
      'details',
      'dfn',
      'dialog',
      'dir',
      'div',
      'dl',
      'dt',
      'element',
      'em',
      'fieldset',
      'figcaption',
      'figure',
      'font',
      'footer',
      'form',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'head',
      'header',
      'hgroup',
      'hr',
      'html',
      'i',
      'img',
      'input',
      'ins',
      'kbd',
      'label',
      'legend',
      'li',
      'main',
      'map',
      'mark',
      'marquee',
      'menu',
      'menuitem',
      'meter',
      'nav',
      'nobr',
      'ol',
      'optgroup',
      'option',
      'output',
      'p',
      'picture',
      'pre',
      'progress',
      'q',
      'rp',
      'rt',
      'ruby',
      's',
      'samp',
      'section',
      'select',
      'shadow',
      'small',
      'source',
      'spacer',
      'span',
      'strike',
      'strong',
      'style',
      'sub',
      'summary',
      'sup',
      'table',
      'tbody',
      'td',
      'template',
      'textarea',
      'tfoot',
      'th',
      'thead',
      'time',
      'tr',
      'track',
      'tt',
      'u',
      'ul',
      'var',
      'video',
      'wbr',

      'svg',
      'a',
      'altglyph',
      'altglyphdef',
      'altglyphitem',
      'animatecolor',
      'animatemotion',
      'animatetransform',
      'circle',
      'clippath',
      'defs',
      'desc',
      'ellipse',
      'filter',
      'font',
      'g',
      'glyph',
      'glyphref',
      'hkern',
      'image',
      'line',
      'lineargradient',
      'marker',
      'mask',
      'metadata',
      'mpath',
      'path',
      'pattern',
      'polygon',
      'polyline',
      'radialgradient',
      'rect',
      'stop',
      'style',
      'switch',
      'symbol',
      'text',
      'textpath',
      'title',
      'tref',
      'tspan',
      'view',
      'vkern',

      'feBlend',
      'feColorMatrix',
      'feComponentTransfer',
      'feComposite',
      'feConvolveMatrix',
      'feDiffuseLighting',
      'feDisplacementMap',
      'feDistantLight',
      'feDropShadow',
      'feFlood',
      'feFuncA',
      'feFuncB',
      'feFuncG',
      'feFuncR',
      'feGaussianBlur',
      'feImage',
      'feMerge',
      'feMergeNode',
      'feMorphology',
      'feOffset',
      'fePointLight',
      'feSpecularLighting',
      'feSpotLight',
      'feTile',
      'feTurbulence',

      'math',
      'menclose',
      'merror',
      'mfenced',
      'mfrac',
      'mglyph',
      'mi',
      'mlabeledtr',
      'mmultiscripts',
      'mn',
      'mo',
      'mover',
      'mpadded',
      'mphantom',
      'mroot',
      'mrow',
      'ms',
      'mspace',
      'msqrt',
      'mstyle',
      'msub',
      'msup',
      'msubsup',
      'mtable',
      'mtd',
      'mtext',
      'mtr',
      'munder',
      'munderover',
      'mprescripts',
      '#text',
      'mention',
    ],
    disallowedTagsMode: 'discard',
    allowedAttributes: {
      '*': [
        'target',
        'data-*',
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns',
        'slot',
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        ...(allowStyle ? ['style'] : []),
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan',
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns',
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink',
      ],
    },
  })
}

export const EncodeUrlRegexMap = {
  edit: /<mocka ([^>]*)data-url="true"[^<>]*>(.*?)<\/mocka>/gim,
  url: /((?:=")|(?:data-url="true">)|)(https?:\/\/(www\.)?(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$]))/gim,
  encodedUrl: /\[a\+href="([^<"]+)"(?:\+text=\"([^<"]+)")?\]/gim,
  editorMention: /<mention [^>]*data-id="([^<"]+)"[^>]*>([^<]+)<\/mention>/gim,
  savedMention: /\[mention\+id="([^<"]+)"([^\]]*)\]/gim,
  rawUrl: /^(https?:\/\/(www\.)?(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$]))$/gim,
  optionalProtocol: /^((https?:\/\/)?(www\.)?(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$]))$/gim,
  encodedUrl2: /<a [^>]*href="([^>"]+)"[^>]*>([^<]+)<\/a>/gim,
}
export const BadWordRegex = /<mocka [^\>]*data-bad-word="[^\"]*" [^\>]*data-error="true"[^\>]*>(.*?)<\/mocka>/gim
export const encodePostUrl = (s: string) =>
  sanitize(
    s
      .replace(/(\&nbsp;)+/g, ' ')
      ?.replace(/(\u200c|&zwnj;)+/g, '')
      .replace(EncodeUrlRegexMap.url, (match, p1, p2) => {
        if (p1 !== '="' && p1 !== 'data-url="true">')
          return `<a href="${p2}" target="_blank">${p2}</a>`
        return match
      })
      .replace(EncodeUrlRegexMap.edit, (_, p1, p2) => {
        const cleanUrl = p1.match(/data-href="([^"]*)"/im)?.[1]
        if (cleanUrl) return `<a href="${cleanUrl}" target="_blank">${p2}</a>`
        return `<a href="${p2}" target="_blank">${p2}</a>`
      }),
  )
export const encodeMention = (s: string) =>
  s.replace(EncodeUrlRegexMap.editorMention, (_, p1, p2) => {
    return `[mention+id="${p1}"+name="${p2}"]`
  })

export const getAnchorHtml = ({
  url,
  text,
  method,
}: {
  url: string
  text: string
  method: string
}) => {
  // remove white space before and after link element, put them outside of current tag
  const trimStartIndex = text.indexOf(text.trimStart())
  const trimEndIndex = text.trimEnd().length
  const preSpaces = text.substring(0, trimStartIndex)
  const trimmedText = text.substring(trimStartIndex, trimEndIndex)
  const postSpaces = text.substring(trimEndIndex)
  if (method === 'edit') {
    return `${preSpaces}<mocka data-href="${url}" data-url="true">${trimmedText}</mocka>${postSpaces}`
  }
  if (method === 'display') {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return `${preSpaces}<a href="${url}" target="_blank">${trimmedText}</a>${postSpaces}`
    }
  }
  return text
}

export const decodePostUrl = (s: string, method: string) =>
  s
    .replace(EncodeUrlRegexMap.encodedUrl, (_, p1, p2) => {
      const text = p2 || p1
      return getAnchorHtml({
        text,
        url: p1,
        method,
      })
    })
    .replace(EncodeUrlRegexMap.encodedUrl2, (_, p1, p2) => {
      const text = p2 || p1
      return getAnchorHtml({
        text,
        url: p1,
        method,
      })
    })
export const decodeMention = (
  s: string,
  users: {
    id: number
    name: string
  }[] = [],
) =>
  s.replace(EncodeUrlRegexMap.savedMention, (_, p1, p2) => {
    const foundUser = users.find((u) => String(u.id) === p1)
    if (!foundUser) {
      if (!p2) return ''
      let tempName = ''
      ;(p2 as string).replace(/\+name="([^<"]+)"/i, (m, _p1) => {
        tempName = _p1
        return m
      })
      return `<mention data-id="${p1}" data-name="${tempName}">${tempName}</mention>`
    }
    return `<mention data-id="${p1}" data-name="${foundUser.name}">${foundUser.name}</mention>`
  })

export const getUrlsFromString = (s: string) => {
  const res: string[] = []
  s.replace(EncodeUrlRegexMap.url, (match, p1, p2) => {
    if (p1 !== '="' && p1 !== 'data-url="true">') {
      res.push(p2)
    }
    return match
  })
  return res
}
export const LIMIT_MENTION = 30

export const getMentionIdsFromString = (s: string, disableLimit?: boolean) => {
  const res: string[] = []
  s.replace(EncodeUrlRegexMap.editorMention, (match, p1) => {
    res.push(p1)
    return match
  }).replace(EncodeUrlRegexMap.savedMention, (match, p1) => {
    res.push(p1)
    return match
  })
  if (!disableLimit) {
    return Array.from(new Set(res)).slice(0, LIMIT_MENTION)
  }
  return res
}
export const getUrlsFromEditorString = (s: string): string[] =>
  [
    ...getUrlsFromString(s),
    ...(s.match(EncodeUrlRegexMap.edit)?.map((s) => {
      const cleanUrl = s.match(/data-href="([^"]*)"/im)?.[1]
      const text = s.match(/>(.*?)<\/mocka>/im)?.[1]
      return cleanUrl || text
    }) || []),
  ].filter((s) => !!s) as string[]

export const escapeRegExp = (string: string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
}

export function escapeHtmlString(html: string, isAttribute?: boolean) {
  const escape = document.createElement('textarea')
  if (!isAttribute) {
    escape.textContent = html
    return escape.innerText
  } else {
    escape.setAttribute('_temp', html)
    return escape.getAttribute('_temp')
  }
}

export function unescapeHtmlString(html: string) {
  const escape = document.createElement('textarea')
  escape.innerHTML = html
  return escape.textContent
}

export const wrapAnchorAroundUrls = (s: string) =>
  s
    .replace(/(\&nbsp;)+/g, ' ')
    ?.replace(/(\u200c|&zwnj;)+/g, '')
    ?.replace(EncodeUrlRegexMap.edit, (_, p1, p2) => {
      const cleanUrl = p1.match(/data-href="([^"]*)"/im)?.[1]
      if (!cleanUrl || cleanUrl === p2 || p2.match(EncodeUrlRegexMap.rawUrl))
        return p2
      if (cleanUrl) return `<a href="${cleanUrl}">${p2}</a>`
      return `<a href="${p2}">${p2}</a>`
    })
    .replace(EncodeUrlRegexMap.url, (match, p1, p2) => {
      if (p1 !== '="' && p1 !== 'data-url="true">') {
        const lowercase = p2.toLowerCase()
        const addHttps = !lowercase.startsWith('http') ? ' https://' : ''
        const url = `${addHttps}${lowercase}`
        return getAnchorHtml({
          text: url,
          url: url,
          method: 'edit',
        })
      }
      return match
    })
    .replace(EncodeUrlRegexMap.encodedUrl2, (_, p1, p2) => {
      const text = p2 || p1
      return getAnchorHtml({
        text: text,
        url: p1,
        method: 'edit',
      })
    })

export const removeEdittedBannedWord = (s: string) =>
  s.replace(BadWordRegex, (s, m1) => {
    const w = document.createElement('div')
    w.innerHTML = s
    const child = w.firstChild as HTMLElement
    if (child?.innerText !== child?.getAttribute('data-bad-word')) return m1
    else return s
  })
export const removeBannedWordWrapper = (s: string) =>
  s.replace(BadWordRegex, '$1')
export const removeFontFormat = (s: string) =>
  s.replace(/<font [^\>]*>(.+)<\/font>/gim, (_, m1) => {
    return m1.replace(/<u[^\>]*>(.+)<\/u>/gim, '$1')
  })

export const encodePostContent = (s: string) =>
  encodePostUrl(encodeMention(removeBannedWordWrapper(s)))

export const ALLOW_DOMAIN_URL = [
  'hellobacsi.com',
  'hellosehat.com',
  'hellodoktor.com',
  'hellokrupet.com',
  'hellodoctor.com.ph',
  'hellokhunmor.com',
  'hellosayarwon.com',
  'helloyishi.com.tw',
  'helloswasthya.com',
  'marrybaby.vn',
]

export const reformatUrl = (s: string) => {
  if (s.match(EncodeUrlRegexMap.optionalProtocol)) {
    if (s.startsWith('https://') || s.startsWith('http://')) return s
    else return `https://${s}`
  }
  return ''
}

export const highlightBadWords = (text: string, bannedWords: string[]) => {
  const filteredBanedWords = bannedWords.filter(Boolean)
  if (text && filteredBanedWords.length > 0) {
    const submitTitle = removeBannedWordWrapper(text)
    return submitTitle.replace(
      new RegExp(
        `\\b(${filteredBanedWords
          .map((banned) => escapeRegExp(banned))
          .join('|')})\\b`,
        'gi',
      ),
      (_, m1) => {
        const escape = document.createElement('mocka')
        escape.setAttribute('data-bad-word', m1)
        escape.setAttribute('data-error', 'true')
        escape.innerText = m1
        return `${escape.outerHTML}`
      },
    )
  }
  return text
}

export const findCategoryBySlug = (
  slugIndex: number,
  slugs: string[],
  categories: Category[],
  returnCategories: Category[],
) => {
  const category = categories.find(
    (c) =>
      c.permalink.indexOf(
        `${basePath}/${slugs.slice(0, slugIndex + 1).join('/')}/`,
      ) > -1,
  )

  category && returnCategories.push(category)

  if (category?.childCates?.[0] && slugIndex < slugs.length - 1) {
    findCategoryBySlug(
      slugIndex + 1,
      slugs,
      category.childCates,
      returnCategories,
    )
  }
}
